import { OrganizationContext } from '../enums/organization-context.enum';
import { DayOfWeek } from '@boma/client-shared';
import { IRole } from './i-role';
import { IImage } from './i-image';

export interface IOrganization {
  id: string;
  sector: string;
  registeredName: string;
  tradingName: string;
  registrationNumber: string;
  country?: string;
  taxNumber: string;
  contactNumber: string;
  physicalAddressLineOne: string;
  physicalAddressLineTwo: string;
  physicalAddressCity: string;
  postalAddressLineOne: string;
  postalAddressLineTwo: string;
  postalAddressCity: string;
  postalAddressPostalCode: number;
  yearEndDate: string;
  weekStart: DayOfWeek;
  webAddress: string;
  countryId: string;
  images: IImage[];
  entityContactPersons: IOrganizationContactPerson[];
  administrators: IOrganizationAdmin[];
  type: OrganizationContext;
}

export interface IOrganizationContactPerson {
  id: string;
  name: string;
  emailAddress: string;
  contactNumber: string;
  type: number;
}

export interface IOrganizationAdmin {
  id: string;
  firstName: string;
  surname: string;
  roles: IRole[];
}

export interface IOrganizationBankAccount {
  countryName: string;
  accountHolderName: string;
  bankName: string;
  swiftAddress: string;
  accountNumber: string;
  branchCode: string;
}
